
import { computed } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  current: {
    key: "current",
    required: true,
    type: Number
  },
  count: {
    key: "count",
    required: true,
    type: Number
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const currentTransform = computed(() => {
    let position = 0;
    if (props.count > 6) {
      if (props.current === props.count - 1) position = (props.current - 5) * 10;else if (props.current > 4) position = (props.current - 5) * 10 + 10;
    }
    return `translateX(-${position}px)`;
  });
  function isSmall(index: number) {
    // точек меньше или равено 6 - сразу выходим, ничего уменьшать не надо
    if (props.count <= 6) return false;
    const isLastOneActive = props.current === props.count - 1;
    // логика для уменьшения левой точки в слайдере
    if (props.current > 4 && (!isLastOneActive && index < props.current - 3 || isLastOneActive && index < props.current - 4)) return true;
    // логики для уменьшения правой точки
    else if (index > 4 && (props.current <= 4 || props.current < index && index !== props.count - 1)) return true;
  }
  return {
    currentTransform,
    isSmall
  };
};
export default __sfc_main;
